<template>
  <v-dialog v-model="dialog" width="400" persistent>
    <v-form @submit.prevent="handleSubmit">
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <MoneyInput
            v-model="input"
            :label="fieldLabel"
            :placeholder="placeholder"
            autofocus
            clearable
            :error-messages="errors"
            @keydown.enter="handleSubmit"
            :color="color"
          ></MoneyInput>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" text> Cancelar </v-btn>
          <v-btn
            type="submit"
            :color="color"
            :dark="!valid ? false : dark"
            :disabled="!valid"
          >
            Gravar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import MoneyInput from "@/components/MoneyInput";

export default {
  mixins: [],

  components: {
    MoneyInput,
  },

  props: {
    title: String,
    fieldLabel: String,
    color: {
      type: String,
      default: "primary",
    },
    dark: {
      type: String,
    },
    optional: Boolean,
    placeholder: String,
  },

  data() {
    return {
      dialog: false,
      errors: [],
      input: 0,
    };
  },

  methods: {
    close() {
      this.dialog = false;
    },

    open(start = 0) {
      this.dialog = true;
      this.input = start;
    },

    handleSubmit() {
      this.dialog = false;
      this.$emit("submit", this.input);
    },
  },

  computed: {
    valid() {
      if (this.optional) {
        return true;
      }

      if (this.input < 0.01) {
        return false;
      }

      return true;
    },
  },
};
</script>
